module.exports = __webpack_public_path__ + "img/scroll6.9a3bab1b.png";